import React, { PureComponent } from 'react';
import OrderHistoryHeader from './OrderHistoryHeader';
import OrderHistoryBody from './OrderHistoryBody';

class OrderHistoryPanel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expanded: true,
    };
  }

  expandCollapseClick = () => {
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  render() {
    const { order, 
            order:{
              orderId
            } 
          } = this.props;
    const groupId = `${orderId}_order_id`;
    const { expanded } = this.state;
    return (
      <div className="panel panel-default" style={{ borderRadius: '0px' }}>
        <OrderHistoryHeader
          order={order}
          group={groupId} 
          expanded={expanded}
          expandCollapseClick={this.expandCollapseClick}
        />
        { expanded ? 
        <OrderHistoryBody 
          group={groupId} 
          order={order}
        /> : null}
      </div>
    );
  }
}

export default OrderHistoryPanel;



// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryPanel/index.jsx